import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetBudgetItemsById = createAsyncThunk(
  "GetBudgetItemsById/GetBudgetItemsById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItems/GetBudgetItemsById",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteBudgetItems = createAsyncThunk(
  "DeleteBudgetItems/DeleteBudgetItems",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItems/DeleteBudgetItems",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateBudgetItems = createAsyncThunk(
  "UpdateBudgetItems/UpdateBudgetItems",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItems/UpdateBudgetItems",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddBudgetItems = createAsyncThunk(
  "AddBudgetItems/AddBudgetItems",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItems/AddBudgetItems",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateBudgetItems = createAsyncThunk(
  "ValidateBudgetItems/ValidateBudgetItems",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItems/ValidateBudgetItems",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const BudgetItemsList = createAsyncThunk(
  "AddBudgetItems/BudgetItemsList",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItems/BudgetItemsList",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const BudgetItems = createSlice({
  name: "BudgetItems",
  initialState: {
    BudgetItems: {},
    loadingBudgetItems: false,
    errorBudgetItems: null,

    AddBudgetItems: {},
    loadingAddBudgetItems: false,
    errorAddBudgetItems: null,

    UpdateBudgetItems: {},
    loadingUpdateBudgetItems: false,
    errorUpdateBudgetItems: null,

    DeleteBudgetItems: {},
    loadingDeleteBudgetItems: false,
    errorDeleteBudgetItems: null,

    BudgetItemsValidate: [],
    loadingBudgetItemsValidate: false,
    errorBudgetItemsValidate: null,

    BudgetItemsList: [],
    loadingBudgetItemsList: false,
    errorBudgetItemsList: null,

    BudgetItemsListTo:[],

  },
  reducers: {
    restValidateBudgetItems: (state, action) => {
      state.BudgetItemsValidate = [];
    },
    BudgetItemsListToFilter: (state, action) => {
      console.log(action.payload,"ssssssdwdwdwd");
      
      state.BudgetItemsListTo = state.BudgetItemsList.filter((ele)=>{
        return ele.budgetItemsId !=action.payload;
      })
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetBudgetItemsById.pending, (state, action) => {
        state.loadingBudgetItems = true;
        state.BudgetItems = action.payload;
        state.errorBudgetItems = null;
      })
      .addCase(GetBudgetItemsById.fulfilled, (state, action) => {
        state.loadingBudgetItems = false;
        state.BudgetItems = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetBudgetItemsById.rejected, (state, action) => {
        state.loadingBudgetItems = false;
        state.errorBudgetItems = action.payload;
      })

      .addCase(DeleteBudgetItems.pending, (state, action) => {
        state.loadingDeleteBudgetItems = true;
        state.DeleteBudgetItems = action.payload;
        state.errorDeleteBudgetItems = null;
      })
      .addCase(DeleteBudgetItems.fulfilled, (state, action) => {
        state.loadingDeleteBudgetItems = false;
        state.DeleteBudgetItems = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteBudgetItems.rejected, (state, action) => {
        state.loadingDeleteBudgetItems = false;
        state.errorDeleteBudgetItems = action.payload;
      })

      .addCase(UpdateBudgetItems.pending, (state, action) => {
        state.loadingUpdateBudgetItems = true;
        state.UpdateBudgetItems = action.payload;
        state.errorUpdateBudgetItems = null;
      })
      .addCase(UpdateBudgetItems.fulfilled, (state, action) => {
        state.loadingUpdateBudgetItems = false;
        state.UpdateBudgetItems = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateBudgetItems.rejected, (state, action) => {
        state.loadingUpdateBudgetItems = false;
        state.errorUpdateBudgetItems = action.payload;
      })

      .addCase(AddBudgetItems.pending, (state, action) => {
        state.loadingBudgetItems = true;
        state.AddBudgetItems = action.payload;
        state.errorAddBudgetItems = null;
      })
      .addCase(AddBudgetItems.fulfilled, (state, action) => {
        state.loadingAddBudgetItems = false;
        state.AddBudgetItems = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddBudgetItems.rejected, (state, action) => {
        state.loadingAddBudgetItems = false;
        state.errorAddBudgetItems = action.payload;
      })

      .addCase(ValidateBudgetItems.pending, (state, action) => {
        state.loadingBudgetItemsValidate = true;
        state.BudgetItemsValidate = action.payload;
        state.errorBudgetItemsValidate = null;
      })
      .addCase(ValidateBudgetItems.fulfilled, (state, action) => {
        state.loadingBudgetItemsValidate = false;
        state.BudgetItemsValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateBudgetItems.rejected, (state, action) => {
        state.loadingBudgetItemsValidate = false;
        state.errorBudgetItemsValidate = action.payload;
      })
      /////////////////////////
      .addCase(BudgetItemsList.pending, (state, action) => {
        state.loadingBudgetItemsList = true;
        state.BudgetItemsList = action.payload;
        state.errorBudgetItemsList = null;
      })
      .addCase(BudgetItemsList.fulfilled, (state, action) => {
        state.loadingBudgetItemsList = false;
        state.BudgetItemsList = action.payload; // Assuming payload has the desired data
      })
      .addCase(BudgetItemsList.rejected, (state, action) => {
        state.loadingBudgetItemsList = false;
        state.errorBudgetItemsList = action.payload;
      });
  },
});
export const { restValidateBudgetItems,BudgetItemsListToFilter   } = BudgetItems.actions;
export default BudgetItems.reducer;
